// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('category/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/category/categoryList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getCategory = createAsyncThunk('category/getCategory', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/category/categoryEdit/${id}`)
    return response.data.Response.item
  } else {
    return response
  }
})

export const addCategory = createAsyncThunk('category/addCategory', async (CreateCategory, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/category/categoryCreate`, {
    Request: {
      CreateCategory
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().categories.params))
  await dispatch(getAllData())
  return CreateCategory
})

export const updateCategory = createAsyncThunk('category/addCategory', async (UpdateCategory, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/category/categoryUpdate`, {
    Request: {
      UpdateCategory
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().categories.params))
  await dispatch(getDataParent())
  return UpdateCategory
})

export const changeStatus = createAsyncThunk('category/changeStatus', async (ChangeStatusCategory, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/category/categoryChangeStatus`, {
    Request: {
      ChangeStatusCategory
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().categories.params))
  return ChangeStatusCategory
})

export const deleteCategory = createAsyncThunk('category/deleteCategory', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/category/categoryDelete/${id}`)

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().categories.params))
  await dispatch(getAllData())
  return id
})

export const appCategoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    data: [],
    dataParent: [],
    total: 1,
    params: {},
    allData: [],
    selectedCategory: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.selectedCategory = action.payload
      })
  }
})

export default appCategoriesSlice.reducer
